import types from '../../constants';

const initialState = {
  showVariables: false,
  variables: {}
};

const ExerciseRunReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.EXERCISE_RUN_SHOW_VARIABLES:
      return {
        ...state,
        showVariables: action.payload,
      };
    case types.EXERCISE_SET_VAR:
      console.log()
      let newVariables = { ...state.variables };

      newVariables[action.payload.key] = action.payload.value;

      return {
        ...state,
        variables: newVariables,
      };
    default:
      return state;
  }
};

export default ExerciseRunReducers;
